// lib
export const isDevEnv = () => {
	if (import.meta.env.MODE === 'development') return true;
	return false;
};

export const domain = 'leadgeek.io';
export const siteUrl = isDevEnv() ? 'https://leadgeek.ngrok.io' : `https://${domain}`;

export default {
	address: {
		line1: '5900 Balcones Drive, Suite 100',
		line2: 'Austin, TX 78731',
	},
	author: 'Jake Hatfield',
	createdAt: '2023-01-01T00:00:00.000+0100',
	description:
		'Leadgeek provides a state-of-the-art online arbitrage marketplace and tools to help Amazon FBA sellers across the world.',
	email: `support@${siteUrl}`,
	ogLanguage: 'en_US',
	siteLanguage: 'en',
	siteTitle: 'Leadgeek',
	siteShortTitle: 'Leadgeek',
	siteUrl,
	social: {
		twitter: 'useleadgeek',
		youtube: 'useleadgeek',
	},
};
